import * as React from 'react';
import { Prompt } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card } from 'material-ui/Card';
import { get, times, sortBy } from 'lodash';
import { SelectField, MenuItem } from 'material-ui';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { compose, withProps, withPropsOnChange } from 'recompose';
import { reduxForm, Field, FieldArray, getFormValues } from 'redux-form';
import { Input, InputField, RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';

import * as T from '@modules/hr-templates/calendars/_calendarsTypes';
import { required } from '@utils/validators';
import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';
import { getCalendarTemplate } from '@modules/hr-templates/calendars/_calendarActions';

const linkBack = '/hr/templates/calendars';

const resizeWeeksArray = (arr: any, newSize: number) => {
  let iterator = arr.length;
  while (newSize > arr.length) {
    arr.push({ week: null, order: iterator++ });
  }
  arr.length = newSize;
};

// Temporaray
const renderWeeksField = ({ input, label, meta: { touched, error }, children, formProps, ...custom }) => (
  <SelectField
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    onChange={(_event, _index, value) => {
      input.onChange(value);
      const oldWeeks = get(formProps, 'values.weekItems', []);
      formProps.change('weekItems', resizeWeeksArray(oldWeeks, value));
    }}
    children={children}
    {...custom}
  />
);

const renderWeeks = ({ fields, meta: { error } }) => (
  <>
    {fields.map((week, index) => (
      <div key={index} style={{ width: 200, marginRight: 5 }}>
        <RemoteAutoCompleteField
          id="type"
          caching={true}
          name={`${week}.week.id`}
          label={`Týden ${index + 1} *`}
          fullWidth={true}
          component={RemoteAutoComplete}
          url="/metropolis/api/hr/workplan/calendar/week"
          labelFunction={o => get(o, 'label')}
          valueFunction={o => get(o, 'id')}
          validate={[required]}
          arrowstyle={{
            color: '#e1e0e1',
            position: 'absolute',
            right: 0,
            top: 16
          }}
        />
        <InputField component={Input} name={`${week}.order`} label="Pořadí" disabled={true} />
      </div>
    ))}
    {error && <div className="error">{error}</div>}
  </>
);

const enhance = compose<T.CalendarsFormProps, T.CalendarsFormProps>(
  EntityDetailEnhancer<T.CalendarEnhancerProps<T.Calendar>, T.Calendar>({
    getEntity: getCalendarTemplate,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Kalendáře', to: linkBack },
    { label: get(entity, 'name', 'Nová šablona pro kalendář') }
  ]),
  withPropsOnChange(['entity'], ({ entity }) => ({
    entity: { ...entity, weekItems: sortBy(get(entity, 'weekItems', []), ['order']) }
  })),
  withProps<{}, T.CalendarsForm>(({ entity }) => ({
    initialValues: get(entity, 'id')
      ? {
          ...entity
        }
      : {
          weeksNumber: 4,
          weekItems: times(4, Number).map((order: number) => ({ week: null, order }))
        }
  })),
  reduxForm({
    form: 'calendarForm'
  }),
  connect(
    state => ({
      values: getFormValues('CalendarsGrid')(state)
    }),
    {}
  )
);

const View: React.SFC<T.CalendarsFormProps> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={6} xl={4}>
              <Row>
                <Col md={12}>
                  <h4>Základní údaje</h4>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={4} xl={2}>
              <Row>
                <Col md={12}>
                  <InputField component={Input} name="label" label="Název *" validate={[required]} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Field<any>
                    name="weeksNumber"
                    component={renderWeeksField}
                    label="Počet týdnů v kalendáři"
                    formProps={props}
                  >
                    {times(12).map((week: any) => (
                      <MenuItem key={`week${week}`} value={week + 1} primaryText={week + 1} />
                    ))}
                  </Field>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={12} xl={12}>
              <Row>
                <Col md={12}>
                  <div style={{ display: 'flex' }}>
                    <FieldArray<any> name="weekItems" component={renderWeeks} />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} containerElement={<Link to={linkBack} />} />
      </Card>
    </form>
  </div>
);

export const CalendarsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-templates/calendars/CalendarsForm.tsx